import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import * as Logger from 'loglevel';
import configureStore from './store/configureStore';
import tokenRenewer from './components/api-authorization/TokenRenew';
import history from './store/History';
import Utilities from 'hub-utilities';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

import './components/post-authorization/libraries/hub-dashboard-framework/styles.module.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
/*
function geoSuccess(geo) {
    console.log(geo);
    document.cookie = 'geodata.latitude=' + geo.coords.latitude;
    document.cookie = 'geodata.longitude=' + geo.coords.longitude;
    document.cookie = 'geodata.accuracy=' + geo.coords.accuracy;
}

function geoError(geo) {
    document.cookie = 'geodata.latitude=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    document.cookie = 'geodata.longitude=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    document.cookie = 'geodata.accuracy=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
}
*/

if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
        (geo) => {
            document.cookie = 'geodata.latitude=' + geo.coords.latitude;
            document.cookie = 'geodata.longitude=' + geo.coords.longitude;
            document.cookie = 'geodata.accuracy=' + geo.coords.accuracy;
        },
        (geo) => {
            document.cookie = 'geodata.latitude=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
            document.cookie = 'geodata.longitude=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
            document.cookie = 'geodata.accuracy=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        });
}   


let loglevel = "error";
const isDevelopment = process.env.NODE_ENV === 'development';
// levels: trace->debug->info->warn->error->silence, from most to least logs

if (isDevelopment || window.location.href.includes("develop")) {
    loglevel = "debug";
} else {
    //No dev log should be printed out for production build
    loglevel = "info";
}

Logger.setLevel(loglevel);


let frame = Utilities.inIframe() ? `IFRAME` : `TOP`;
if (window.location.pathname === '/authentication/silent-renew-callback') {
    Logger.debug(`====================================== Hub Silent renew started window=${frame} =================================================`);
    Logger.debug(window.location);
    tokenRenewer.completeRenew(window.location.href);
}
else {
    Logger.debug(`====================================== Hub started window=${frame} =================================================`);
    // Get the application-wide store instance, prepopulating with state from the server where available.
    Logger.debug(window.initialReduxState);
    const initialState = window.initialReduxState;
    const store = configureStore(history, initialState, isDevelopment);
    const state = store.getState();
    Logger.debug('store created: ', state);
    const rootElement = document.getElementById('root');
    const root = createRoot(rootElement)
    root.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: http://bit.ly/CRA-PWA
    serviceWorker.unregister();

}
